module.exports = __webpack_public_path__ + "img/sourceLogo.0aedbe42.png";